import { render, staticRenderFns } from "./lookDetail.vue?vue&type=template&id=508b58c4&scoped=true"
import script from "./lookDetail.vue?vue&type=script&lang=js"
export * from "./lookDetail.vue?vue&type=script&lang=js"
import style0 from "./lookDetail.vue?vue&type=style&index=0&id=508b58c4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508b58c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('508b58c4')) {
      api.createRecord('508b58c4', component.options)
    } else {
      api.reload('508b58c4', component.options)
    }
    module.hot.accept("./lookDetail.vue?vue&type=template&id=508b58c4&scoped=true", function () {
      api.rerender('508b58c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/announcement/lookDetail.vue"
export default component.exports